@if(visible()){
<!-- <div class="jk-combobox-border"> -->
<app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
  [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
<div>
  <mat-select [(ngModel)]="value"
    class="w-full flex-1 min-w-12 outline-none border-b border-gray-300 focus:border-blue-500 transition-colors bg-gray-100"
    (valueChange)="onValueChange($event)" [matTooltip]="value">
    @if(canSpace()){
    <mat-option value="">[空白]</mat-option> <!-- 空白選項 -->
    }
    @for(idNameItem of items(); track idNameItem) {
    <mat-option [value]="idNameItem.id">{{idNameItem.name}}</mat-option>
    }
  </mat-select>
</div>
}
